import { useEffect, useRef } from "react";

/** once `logData` is stable, after a `delay`, console.log the `logData` (if this component is still mounted) */
export function LogAfterTimeout({
  logData,
  delay,
}: {
  logData: any;
  delay: number;
}) {
  const timerRef = useRef<number | null>(null);
  useEffect(() => {
    timerRef.current = window.setTimeout(() => {
      console.log("🕵️‍♀️ LogAfterTimeout:", logData);
    }, delay);
    return () => {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
    };
  }, [delay, logData]);

  return null;
}
